import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, ArrowLeft, AlertCircle, CheckCircle, Loader2 } from 'lucide-react';
import '../styles/auth.css';
import { API_BASE_URL } from '../../src/config';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null); // { type: 'success' | 'error', message }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) {
      setStatus({ type: 'error', message: 'Please enter your email address.' });
      return;
    }

    setLoading(true);
    setStatus(null);
    try {
      const res = await fetch(`${API_BASE_URL}/api/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim() }),
      });
      const data = await res.json();
      setStatus({ type: 'success', message: data.message });
    } catch {
      setStatus({ type: 'success', message: 'If an account matches that email, we have sent a password reset link. If it doesn\'t appear within a few minutes, check your spam folder.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-page__body">
        <div className="auth-regis-page__inner">
          <div className="auth-card" style={{ maxWidth: 440 }}>
            <div style={{ textAlign: 'center' }}>
              <div style={{
                width: 56, height: 56, borderRadius: 16,
                background: `
                  radial-gradient(120% 140% at 12% 8%, rgba(84, 168, 255, 0.26) 0%, rgba(84, 168, 255, 0) 48%),
                  radial-gradient(120% 130% at 88% 92%, rgba(75, 130, 220, 0.3) 0%, rgba(75, 130, 220, 0) 44%),
                  radial-gradient(120% 110% at 46% 102%, rgba(39, 96, 184, 0.34) 0%, rgba(39, 96, 184, 0) 56%),
                  linear-gradient(152deg, #071a2d 0%, #0c2d4d 46%, #123e67 100%)
                `,
                color: '#fff', display: 'inline-flex', alignItems: 'center',
                justifyContent: 'center', marginBottom: 16
              }}>
                <Mail size={28} />
              </div>
              <h2 style={{ margin: '0 0 8px', fontSize: 24, fontWeight: 700, color: '#0f172a' }}>
                Forgot your password?
              </h2>
              <p style={{ margin: 0, color: '#64748b', fontSize: 15, lineHeight: 1.6 }}>
                Enter your email address and we'll send you a link to reset your password.
              </p>
            </div>

            {status && (
              <div
                className="auth-card__field-error"
                style={status.type === 'success' ? {
                  background: 'rgba(34, 197, 94, 0.1)',
                  border: '1px solid rgba(34, 197, 94, 0.25)',
                  color: '#15803d',
                } : {}}
              >
                {status.type === 'success' ? <CheckCircle size={16} /> : <AlertCircle size={16} />}
                <span>{status.message}</span>
              </div>
            )}

            {!status?.type || status.type === 'error' ? (
              <form className="auth-card__form" onSubmit={handleSubmit}>
                <div className="auth-card__field">
                  <label htmlFor="reset-email">Email address</label>
                  <div className="auth-card__input">
                    <Mail size={18} />
                    <input
                      id="reset-email"
                      type="email"
                      placeholder="you@example.com"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      autoFocus
                    />
                  </div>
                </div>
                <button type="submit" className="auth-card__submit" disabled={loading}>
                  {loading ? <Loader2 size={18} className="spin" /> : null}
                  {loading ? 'Sending...' : 'Send Reset Link'}
                </button>
              </form>
            ) : null}

            <div className="auth-card__footer">
              <Link to="/login" style={{
                display: 'inline-flex', alignItems: 'center', gap: 6,
                color: '#0d2047ff', fontWeight: 600, textDecoration: 'none', fontSize: 14
              }}>
                <ArrowLeft size={16} /> Back to Login
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
